export default "__VITE_ASSET__LNfk3Ccu__"